export default __webpack_public_path__ + "static/centralized-data-a445b9f5c86c13c7bbaf98e004d4b60c.png";